export default __webpack_public_path__ + "static/media/icon_italic_Type.f2167cfa.svg";